/*
 * Almarzooqi Atelier — product page script
 * <media-gallery>: main media + thumbnails, swipe, keyboard, image viewer with zoom.
 * <product-info>: variant selection, CUSTOMIZE YOUR PIECE validation, colour
 * catalogue, and AJAX add to cart with line item properties.
 * Custom elements initialise on connect, so theme editor reloads start clean.
 */
(function () {
  'use strict';

  var theme = window.theme || { strings: {}, routes: {} };
  var strings = theme.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isRTL() {
    return document.documentElement.getAttribute('dir') === 'rtl';
  }

  function fill(template, values) {
    if (theme.utils && theme.utils.formatString) return theme.utils.formatString(template, values);
    return String(template || '').replace(/\[(\w+)\]/g, function (m, key) { return values[key] != null ? values[key] : ''; });
  }

  function announce(message) {
    if (theme.utils && theme.utils.announce) theme.utils.announce(message);
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    var template = format || '{{amount}}';
    function delimit(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = template.match(pattern);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = delimit(cents, 2, ' ', '.'); break;
      default: value = delimit(cents, 2);
    }
    return template.replace(pattern, value).replace(/<[^>]*>/g, '');
  }

  function toLatinDigits(value) {
    return String(value)
      .replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); })
      .replace(/[۰-۹]/g, function (d) { return String(d.charCodeAt(0) - 0x06F0); })
      .replace(/٫/g, '.');
  }

  function storage() {
    try {
      var key = '__t';
      window.sessionStorage.setItem(key, '1');
      window.sessionStorage.removeItem(key);
      return window.sessionStorage;
    } catch (e) {
      return null;
    }
  }

  /* =====================================================================
     Media gallery
     ===================================================================== */
  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.track = this.querySelector('[data-gallery-track]');
        if (!this.track) return;
        this.slides = Array.prototype.slice.call(this.track.querySelectorAll('.gallery__slide'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
        this.prev = this.querySelector('[data-gallery-prev]');
        this.next = this.querySelector('[data-gallery-next]');
        this.counter = this.querySelector('[data-gallery-current]');
        this.viewer = this.querySelector('[data-media-viewer]');
        this.index = 0;

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.addEventListener('click', this.onClick);
        this.track.addEventListener('keydown', this.onKeydown);

        if ('IntersectionObserver' in window && this.slides.length > 1) {
          var self = this;
          this.observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;
              var seen = self.slides.indexOf(entry.target);
              /* While a programmatic scroll is travelling, ignore the slides it passes. */
              if (self._pending != null) {
                if (seen !== self._pending) return;
                self._pending = null;
              }
              self.setActive(seen);
            });
          }, { root: this.track, threshold: [0.6] });
          this.slides.forEach(function (slide) { self.observer.observe(slide); });
        }

        var initial = this.dataset.activeMedia;
        if (initial) this.goToMedia(initial, false);
        this.updateControls();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onClick(event) {
        if (event.target.closest('[data-gallery-prev]')) {
          this.go(this.index - 1);
        } else if (event.target.closest('[data-gallery-next]')) {
          this.go(this.index + 1);
        } else {
          var thumb = event.target.closest('[data-thumb]');
          if (thumb) {
            this.goToMedia(thumb.getAttribute('data-media-id'), true);
            return;
          }
          var opener = event.target.closest('[data-viewer-open]');
          if (opener) {
            this.openViewer(opener.getAttribute('data-media-id'), opener);
            return;
          }
          var zoom = event.target.closest('[data-viewer-zoom]');
          if (zoom) this.toggleZoom(zoom);
        }
      }

      onKeydown(event) {
        var forward = isRTL() ? 'ArrowLeft' : 'ArrowRight';
        var back = isRTL() ? 'ArrowRight' : 'ArrowLeft';
        if (event.key === forward) {
          event.preventDefault();
          this.go(this.index + 1);
        } else if (event.key === back) {
          event.preventDefault();
          this.go(this.index - 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          this.go(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          this.go(this.slides.length - 1);
        }
      }

      go(index, smooth) {
        if (!this.slides.length) return;
        var target = Math.max(0, Math.min(this.slides.length - 1, index));
        var behavior = smooth === false || reduceMotion.matches ? 'auto' : 'smooth';
        var slide = this.slides[target];
        var self = this;
        this._pending = behavior === 'smooth' ? target : null;
        clearTimeout(this._pendingTimer);
        this._pendingTimer = setTimeout(function () { self._pending = null; }, 1200);
        var trackRect = this.track.getBoundingClientRect();
        var slideRect = slide.getBoundingClientRect();
        /*
         * Scroll to an absolute position. A relative scrollBy() is stopped at the
         * very next photo by scroll-snap-stop, so a thumbnail several photos away
         * (typically the colour catalogue, the last one) would not open.
         */
        this.track.scrollTo({ left: this.track.scrollLeft + (slideRect.left - trackRect.left), behavior: behavior });
        this.setActive(target);
      }

      goToMedia(mediaId, smooth) {
        var index = this.slides.findIndex(function (slide) { return slide.getAttribute('data-media-id') === String(mediaId); });
        if (index > -1) this.go(index, smooth);
      }

      setActive(index) {
        if (index < 0 || index === this.index && this._activated) return;
        this._activated = true;
        this.index = index;
        var activeId = this.slides[index] && this.slides[index].getAttribute('data-media-id');
        this.slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
          if (i !== index) {
            slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
          }
        });
        this.thumbs.forEach(function (thumb) {
          var active = thumb.getAttribute('data-media-id') === activeId;
          thumb.classList.toggle('is-active', active);
          if (active) {
            thumb.setAttribute('aria-current', 'true');
            var list = thumb.closest('[data-gallery-thumbs]');
            if (list && list.scrollWidth > list.clientWidth) {
              var listRect = list.getBoundingClientRect();
              var thumbRect = thumb.getBoundingClientRect();
              if (thumbRect.left < listRect.left || thumbRect.right > listRect.right) {
                list.scrollBy({ left: thumbRect.left - listRect.left - listRect.width / 2 + thumbRect.width / 2, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
              }
            }
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
        if (this.counter) this.counter.textContent = index + 1;
        this.updateControls();
      }

      updateControls() {
        if (this.prev) this.prev.disabled = this.index <= 0;
        if (this.next) this.next.disabled = this.index >= this.slides.length - 1;
      }

      openViewer(mediaId, trigger) {
        if (!this.viewer || !theme.dialog) return;
        theme.dialog.open(this.viewer, trigger);
        var item = this.viewer.querySelector('[data-media-id="' + mediaId + '"]');
        if (item) {
          window.requestAnimationFrame(function () {
            item.scrollIntoView({ block: 'start' });
            var button = item.querySelector('[data-viewer-zoom]');
            if (button) button.focus({ preventScroll: true });
          });
        }
      }

      toggleZoom(button) {
        var item = button.closest('.viewer__item');
        if (!item) return;
        var zoomed = !item.classList.contains('is-zoomed');
        item.classList.toggle('is-zoomed', zoomed);
        button.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
        if (zoomed) {
          window.requestAnimationFrame(function () {
            var offset = (item.scrollWidth - item.clientWidth) / 2;
            item.scrollLeft = isRTL() ? -offset : offset;
          });
        }
      }
    });
  }

  /* =====================================================================
     Product information, customization, catalogue and add to cart
     ===================================================================== */
  if (!customElements.get('product-info')) {
    customElements.define('product-info', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.formId = this.dataset.formId;
        this.form = document.getElementById(this.formId);
        this.productId = this.dataset.productId;
        this.isCustom = this.dataset.custom === 'true';
        this.draftKey = 'almarzooqi:custom:' + this.productId;
        this.store = storage();

        var jsonEl = this.querySelector('[data-product-json]');
        try {
          this.product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
        } catch (e) {
          this.product = null;
        }

        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.addEventListener('input', this.onInput);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('focusout', this.onBlur.bind(this));

        if (this.form) {
          this.form.noValidate = true;
          this.form.addEventListener('submit', this.onSubmit);
        }

        /* Save typed values when the customer leaves or reloads the page. */
        this.onPageHide = this.saveDraft.bind(this);
        window.addEventListener('pagehide', this.onPageHide);

        /* Sample photos that fail to load are removed rather than shown broken. */
        this.addEventListener('error', this.onMediaError.bind(this), true);

        this.sizing = this.querySelector('[data-sizing]');
        this.restoreDraft();
        this.applySizeType(this.checkedSizeType());
        this.applyFabricSuggestion();
        this.updateUnavailableOptions();
      }

      disconnectedCallback() {
        if (this.onPageHide) window.removeEventListener('pagehide', this.onPageHide);
        clearTimeout(this._draftTimer);
      }

      onMediaError(event) {
        var img = event.target;
        if (!img || !img.matches || !img.matches('[data-hide-on-error]')) return;
        var item = img.closest('li');
        if (item) item.hidden = true;
        var panel = img.closest('[data-catalog-panel]');
        if (panel && !panel.querySelector('.catalog__grid li:not([hidden])')) {
          var note = panel.querySelector('[data-catalog-panel-empty]');
          if (note) note.hidden = false;
        }
      }

      /* ---------------- Ready-made sizes or custom measurements ---------------- */
      checkedSizeType() {
        if (!this.sizing) return null;
        var checked = this.sizing.querySelector('[data-size-type]:checked');
        return checked ? checked.getAttribute('data-size-type') : null;
      }

      applySizeType(type) {
        if (!this.sizing) return;
        var self = this;
        this.sizing.querySelectorAll('[data-size-group]').forEach(function (group) {
          var active = group.getAttribute('data-size-group') === type;
          group.hidden = !active;
          group.querySelectorAll('[data-custom-field]').forEach(function (field) {
            var input = self.inputFor(field);
            if (!input) return;
            input.disabled = !active;
            if (!active) self.clearFieldError(field);
          });
          /* Ready-made pills: only the active mode may submit anything. */
          group.querySelectorAll('[data-ready-input]').forEach(function (input) {
            input.disabled = !active;
          });
          if (!active) {
            group.querySelectorAll('[data-size-choice]').forEach(function (choice) {
              self.clearChoiceError(choice);
            });
          }
        });
        this.updateReadyMade();
      }

      /* ---------------- Ready-made: standard size + length ---------------- */
      readyActive() {
        return this.checkedSizeType() === 'ready';
      }

      checkedReady(selector) {
        if (!this.sizing) return null;
        return this.sizing.querySelector(selector + ':checked');
      }

      /*
       * Bust, hip and underarm come from the chosen size; shoulder comes from the
       * chosen length. Both are read from explicit data- attributes on the input
       * that was picked, never from its position in the list.
       */
      updateReadyMade() {
        if (!this.sizing) return;
        var active = this.readyActive();
        var size = active ? this.checkedReady('[data-ready-size]') : null;
        var length = active ? this.checkedReady('[data-ready-length]') : null;
        var derived = {
          bust: size ? size.getAttribute('data-bust') : '',
          hip: size ? size.getAttribute('data-hip') : '',
          underarm: size ? size.getAttribute('data-underarm') : '',
          shoulder: length ? length.getAttribute('data-shoulder') : ''
        };

        this.sizing.querySelectorAll('[data-derived]').forEach(function (input) {
          var value = derived[input.getAttribute('data-derived')] || '';
          input.value = value;
          input.disabled = !active || value === '';
        });

        var summary = this.sizing.querySelector('[data-ready-summary]');
        if (!summary) return;
        if (!active || !size || !length) {
          summary.hidden = true;
          return;
        }
        var inch = strings.unitInch || '';
        function withUnit(value) { return inch ? value + ' ' + inch : value; }
        var main = summary.querySelector('[data-ready-summary-main]');
        var detail = summary.querySelector('[data-ready-summary-detail]');
        if (main) {
          main.textContent = size.value + ' · ' + fill(strings.summaryLength, { length: withUnit(length.value) });
        }
        if (detail) {
          detail.textContent = [
            strings.labelShoulder + ' ' + withUnit(derived.shoulder),
            strings.labelBust + ' ' + withUnit(derived.bust),
            strings.labelHip + ' ' + withUnit(derived.hip),
            strings.labelUnderarm + ' ' + withUnit(derived.underarm)
          ].join(' · ');
        }
        summary.hidden = false;
      }

      clearChoiceError(choice) {
        var error = choice.querySelector('[data-size-choice-error]');
        choice.querySelectorAll('[data-ready-input]').forEach(function (input) {
          input.removeAttribute('aria-invalid');
        });
        if (error) {
          error.textContent = '';
          error.hidden = true;
        }
      }

      validateReadyChoices() {
        if (!this.sizing || !this.readyActive()) return null;
        var self = this;
        var first = null;
        this.sizing.querySelectorAll('[data-size-choice]').forEach(function (choice) {
          var inputs = Array.prototype.slice.call(choice.querySelectorAll('[data-ready-input]'));
          var chosen = inputs.some(function (input) { return input.checked; });
          if (chosen) {
            self.clearChoiceError(choice);
            return;
          }
          var error = choice.querySelector('[data-size-choice-error]');
          inputs.forEach(function (input) { input.setAttribute('aria-invalid', 'true'); });
          if (error) {
            error.textContent = choice.getAttribute('data-size-choice') === 'length' ? strings.errorLength : strings.errorSize;
            error.hidden = false;
          }
          if (!first) first = inputs[0] || null;
        });
        return first;
      }

      validateSizing() {
        if (!this.sizing) return null;
        var error = this.sizing.querySelector('[data-size-type-error]');
        var radios = Array.prototype.slice.call(this.sizing.querySelectorAll('[data-size-type]'));
        if (this.checkedSizeType()) {
          radios.forEach(function (r) { r.removeAttribute('aria-invalid'); });
          if (error) {
            error.textContent = '';
            error.hidden = true;
          }
          return null;
        }
        radios.forEach(function (r) { r.setAttribute('aria-invalid', 'true'); });
        if (error) {
          error.textContent = strings.errorSizeType;
          error.hidden = false;
        }
        return radios[0] || null;
      }

      clearFieldError(field) {
        var input = this.inputFor(field);
        var error = field.querySelector('[data-field-error]');
        if (input) input.removeAttribute('aria-invalid');
        if (error) {
          error.textContent = '';
          error.hidden = true;
        }
      }

      /* ---------------- Elements ---------------- */
      customFields() {
        return Array.prototype.slice.call(this.querySelectorAll('[data-custom-field]'));
      }

      inputFor(field) {
        return field.querySelector('[data-custom-input]');
      }

      /* ---------------- Events ---------------- */
      onClick(event) {
        var qtyStep = event.target.closest('[data-qty-step]');
        if (qtyStep) {
          var qtyInput = this.querySelector('[data-qty-input]');
          if (qtyInput) {
            var current = parseInt(qtyInput.value, 10) || 1;
            qtyInput.value = Math.max(1, current + Number(qtyStep.getAttribute('data-qty-step')));
          }
          return;
        }

        /* "View color catalog": show the catalogue photo in the product gallery. */
        var catalogShow = event.target.closest('[data-catalog-show]');
        if (catalogShow) {
          event.preventDefault();
          this.showCatalogImage(catalogShow.getAttribute('data-catalog-show'));
          return;
        }

        var catalogOpen = event.target.closest('[data-catalog-open]');
        if (catalogOpen) {
          event.preventDefault();
          this.openCatalog(catalogOpen);
          return;
        }

        var tab = event.target.closest('[data-catalog-tab]');
        if (tab) {
          this.selectTab(tab, true);
          return;
        }

        var swatch = event.target.closest('[data-swatch]');
        if (swatch) {
          this.pickSwatch(swatch);
          return;
        }

        if (event.target.closest('[data-catalog-replace]')) {
          if (this.pendingPick) this.applyPick(this.pendingPick);
          return;
        }

        if (event.target.closest('[data-catalog-keep]')) {
          this.hideConfirm(true);
          return;
        }

        var sheetZoom = event.target.closest('[data-sheet-zoom]');
        if (sheetZoom) {
          var sheet = sheetZoom.closest('[data-sheet]');
          var zoomed = !sheet.classList.contains('is-zoomed');
          sheet.classList.toggle('is-zoomed', zoomed);
          sheetZoom.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
          sheetZoom.textContent = zoomed ? strings.zoomOut : strings.zoomIn;
          if (zoomed) {
            var frame = sheet.querySelector('[data-sheet-frame]');
            window.requestAnimationFrame(function () {
              var offset = (frame.scrollWidth - frame.clientWidth) / 2;
              frame.scrollLeft = isRTL() ? -offset : offset;
            });
          }
        }
      }

      onChange(event) {
        var target = event.target;
        if (target.matches('[data-option-input]')) {
          this.onVariantChange(target);
        } else if (target.matches('[data-size-type]')) {
          this.applySizeType(target.getAttribute('data-size-type'));
          if (this.attempted) {
            this.validateSizing();
            this.validateReadyChoices();
          }
          this._draftCleared = false;
          this.saveDraft();
        } else if (target.matches('[data-ready-input]')) {
          var choice = target.closest('[data-size-choice]');
          if (choice) this.clearChoiceError(choice);
          this.updateReadyMade();
          this._draftCleared = false;
          this.saveDraft();
        } else if (target.matches('[data-addon]')) {
          this._draftCleared = false;
          this.saveDraft();
        } else if (target.matches('select[data-custom-input]')) {
          this.validateField(target.closest('[data-custom-field]'));
          this._draftCleared = false;
          this.saveDraft();
        }
      }

      onInput(event) {
        var input = event.target;
        if (!input.matches('[data-custom-input]')) return;
        var field = input.closest('[data-custom-field]');

        /* A manual edit that no longer matches the picked sample clears its catalogue reference. */
        if (input.dataset.catalogValue != null && input.value.trim() !== input.dataset.catalogValue) {
          this.clearCatalogSource(field);
        }
        if (field.getAttribute('data-field') === 'fabric') {
          var prefillHint = field.querySelector('[data-prefill-hint]');
          if (prefillHint && input.value.trim() !== input.dataset.suggested) prefillHint.hidden = true;
        }
        if (input.getAttribute('aria-invalid') === 'true') this.validateField(field);
        this.saveDraftSoon();
      }

      onBlur(event) {
        var input = event.target;
        if (!input.matches || !input.matches('[data-custom-input]')) return;
        var field = input.closest('[data-custom-field]');
        if (field && (this.attempted || input.value.trim() !== '')) this.validateField(field);
      }

      onKeydown(event) {
        var tab = event.target.closest && event.target.closest('[data-catalog-tab]');
        if (!tab) return;
        var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[data-catalog-tab]'));
        var index = tabs.indexOf(tab);
        var forward = isRTL() ? 'ArrowLeft' : 'ArrowRight';
        var back = isRTL() ? 'ArrowRight' : 'ArrowLeft';
        var next = null;
        if (event.key === forward) next = tabs[(index + 1) % tabs.length];
        else if (event.key === back) next = tabs[(index - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          event.preventDefault();
          this.selectTab(next, true);
        }
      }

      /* ---------------- Colour catalogue (a photo in the gallery) ---------------- */
      showCatalogImage(mediaId) {
        var gallery = this.querySelector('media-gallery');
        if (!gallery || !mediaId) return;
        if (gallery.goToMedia) gallery.goToMedia(mediaId, false);
        var rect = gallery.getBoundingClientRect();
        var headerH = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0;
        if (rect.top < headerH || rect.top > window.innerHeight * 0.6) {
          window.scrollTo({
            top: Math.max(0, window.pageYOffset + rect.top - headerH - 12),
            behavior: reduceMotion.matches ? 'auto' : 'smooth'
          });
        }
      }

      /* ---------------- Paid add-ons (Add Al Oqom) ---------------- */
      checkedAddons() {
        return Array.prototype.slice.call(this.querySelectorAll('[data-addon]:checked')).filter(function (el) {
          return !el.disabled;
        });
      }

      /* An add-on must point at a real variant, otherwise it would not be charged. */
      invalidAddon() {
        var invalid = null;
        this.checkedAddons().forEach(function (el) {
          var id = String(el.getAttribute('data-addon-variant') || '');
          if (!/^\d+$/.test(id) || id === '0') invalid = el;
        });
        return invalid;
      }

      /* ---------------- Variants ---------------- */
      selectedOptions() {
        return Array.prototype.slice.call(this.querySelectorAll('[data-variant-picker] fieldset')).map(function (fieldset) {
          var checked = fieldset.querySelector('[data-option-input]:checked');
          return checked ? checked.value : null;
        });
      }

      findVariant(options) {
        if (!this.product || !this.product.variants) return null;
        return this.product.variants.find(function (variant) {
          return options.every(function (value, i) { return variant.options[i] === value; });
        }) || null;
      }

      onVariantChange(input) {
        var fieldset = input.closest('fieldset');
        var label = fieldset && fieldset.querySelector('[data-selected-value]');
        if (label) label.textContent = input.value;

        var variant = this.findVariant(this.selectedOptions());
        var status = this.querySelector('[data-variant-status]');
        var idInput = this.form && this.form.querySelector('[data-variant-id]');
        var button = this.form && this.form.querySelector('[data-add-button]');
        var buttonLabel = button && button.querySelector('[data-add-label]');

        if (!variant) {
          if (idInput) idInput.disabled = true;
          if (button) button.disabled = true;
          if (buttonLabel) buttonLabel.textContent = strings.unavailable;
          if (status) status.textContent = strings.unavailable;
          this.updateUnavailableOptions();
          return;
        }

        if (idInput) {
          idInput.disabled = false;
          idInput.value = variant.id;
        }
        if (button) button.disabled = !variant.available;
        if (buttonLabel) buttonLabel.textContent = variant.available ? strings.addToCart : strings.soldOut;
        if (status) status.textContent = variant.available ? '' : strings.soldOut;

        this.renderPrice(variant);
        this.updateUnavailableOptions();

        if (variant.featured_media) {
          var gallery = this.querySelector('media-gallery');
          if (gallery && gallery.goToMedia) gallery.goToMedia(variant.featured_media.id, true);
        }

        if (window.history.replaceState && this.dataset.productUrl) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      renderPrice(variant) {
        var price = this.querySelector('[data-price-wrapper] [data-price]');
        if (!price) return;
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        price.classList.toggle('price--sale', !!onSale);
        price.classList.toggle('price--sold-out', !variant.available);
        price.textContent = '';

        function span(className, text, dir) {
          var el = document.createElement(className === 's' ? 's' : 'span');
          if (className && className !== 's') el.className = className;
          if (dir) el.setAttribute('dir', dir);
          el.textContent = text;
          return el;
        }

        if (onSale) {
          price.appendChild(span('visually-hidden', strings.salePrice));
          price.appendChild(span('price__current', formatMoney(variant.price, theme.moneyFormat), 'ltr'));
          price.appendChild(span('visually-hidden', strings.regularPrice));
          var compare = span('s', formatMoney(variant.compare_at_price, theme.moneyFormat), 'ltr');
          compare.className = 'price__compare';
          price.appendChild(compare);
        } else {
          price.appendChild(span('price__current', formatMoney(variant.price, theme.moneyFormat), 'ltr'));
        }
        if (!variant.available) price.appendChild(span('price__status', strings.soldOut));
      }

      updateUnavailableOptions() {
        if (!this.product || !this.product.variants) return;
        var selected = this.selectedOptions();
        var variants = this.product.variants;
        this.querySelectorAll('[data-variant-picker] fieldset').forEach(function (fieldset, optionIndex) {
          fieldset.querySelectorAll('[data-option-input]').forEach(function (input) {
            var candidate = selected.slice();
            candidate[optionIndex] = input.value;
            var available = variants.some(function (variant) {
              return variant.available && candidate.every(function (value, i) { return value == null || variant.options[i] === value; });
            });
            var pill = input.nextElementSibling;
            if (pill) pill.classList.toggle('is-unavailable', !available);
          });
        });
      }

      /* ---------------- Customization ---------------- */
      applyFabricSuggestion() {
        var params = new URLSearchParams(window.location.search);
        var field = this.querySelector('[data-custom-field][data-field="fabric"]');
        if (!field) return;
        var input = this.inputFor(field);
        if (!input || input.value.trim() !== '') return;
        /* A fabric chosen on a MADE FOR YOU tile wins over the piece's own material. */
        var suggestion = (params.get('fabric') || input.getAttribute('data-suggested-default') || '').trim().slice(0, 80);
        if (!suggestion) return;
        input.value = suggestion;
        input.dataset.suggested = suggestion;
        var hint = field.querySelector('[data-prefill-hint]');
        if (hint) {
          hint.textContent = fill(strings.suggestedFabric, { fabric: suggestion });
          hint.hidden = false;
        }
      }

      validateField(field) {
        var input = this.inputFor(field);
        if (!input) return true;
        if (input.disabled) {
          this.clearFieldError(field);
          return true;
        }
        var value = input.value.trim();
        var type = field.getAttribute('data-field');
        var label = field.getAttribute('data-label') || '';
        var message = '';

        if (input.required && value === '') {
          if (type === 'fabric') message = strings.errorFabric;
          else if (type === 'color') message = strings.errorColor;
          else if (input.tagName === 'SELECT') message = fill(strings.errorChoose, { field: label });
          else message = fill(strings.errorRequired, { field: label });
        } else if (value !== '' && field.getAttribute('data-numeric') === 'true') {
          var normalised = toLatinDigits(value).replace(',', '.');
          var number = Number(normalised);
          var unit = field.getAttribute('data-unit') || '';
          var min = field.getAttribute('data-min');
          var max = field.getAttribute('data-max');
          if (normalised === '' || !isFinite(number)) {
            message = strings.errorNumber;
          } else if (min !== null && min !== '' && number < Number(min)) {
            message = fill(strings.errorMin, { min: min, unit: unit });
          } else if (max !== null && max !== '' && number > Number(max)) {
            message = fill(strings.errorMax, { max: max, unit: unit });
          }
        }

        var error = field.querySelector('[data-field-error]');
        if (message) {
          input.setAttribute('aria-invalid', 'true');
          if (error) {
            error.textContent = message;
            error.hidden = false;
          }
        } else {
          input.removeAttribute('aria-invalid');
          if (error) {
            error.textContent = '';
            error.hidden = true;
          }
        }
        return !message;
      }

      validateAll() {
        var self = this;
        var invalid = [];
        this.customFields().forEach(function (field) {
          var input = self.inputFor(field);
          if (!input || input.getAttribute('form') !== self.formId) return;
          if (!self.validateField(field)) invalid.push(input);
        });
        var sizingInvalid = this.validateSizing();
        if (sizingInvalid) invalid.push(sizingInvalid);
        var readyInvalid = this.validateReadyChoices();
        if (readyInvalid) invalid.push(readyInvalid);
        invalid.sort(function (a, b) {
          return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
        });
        return invalid[0] || null;
      }

      /* ---------------- Drafts (keep typed values across reloads in this tab) ---------------- */
      saveDraftSoon() {
        var self = this;
        this._draftCleared = false;
        clearTimeout(this._draftTimer);
        this._draftTimer = setTimeout(function () { self.saveDraft(); }, 300);
      }

      saveDraft() {
        if (!this.store || this._draftCleared) return;
        var data = {};
        var self = this;
        this.customFields().forEach(function (field) {
          var input = self.inputFor(field);
          if (!input) return;
          var entry = { v: input.value };
          var source = field.querySelector('[data-catalog-source]');
          if (source && !source.disabled && input.dataset.catalogValue != null) {
            entry.c = source.value;
            entry.cv = input.dataset.catalogValue;
          }
          data[input.id] = entry;
        });
        data.__addons = this.checkedAddons().map(function (el) { return el.id; });
        if (this.sizing) {
          data.__sizeType = this.checkedSizeType();
          var readySize = this.sizing.querySelector('[data-ready-size]:checked');
          var readyLength = this.sizing.querySelector('[data-ready-length]:checked');
          data.__readySize = readySize ? readySize.value : '';
          data.__readyLength = readyLength ? readyLength.value : '';
        }
        try {
          this.store.setItem(this.draftKey, JSON.stringify(data));
        } catch (e) { /* storage full or blocked */ }
      }

      restoreDraft() {
        if (!this.store) return;
        var raw;
        try {
          raw = this.store.getItem(this.draftKey);
        } catch (e) {
          return;
        }
        if (!raw) return;
        var data;
        try {
          data = JSON.parse(raw);
        } catch (e) {
          return;
        }
        var self = this;
        (data.__addons || []).forEach(function (id) {
          var addon = document.getElementById(id);
          if (addon && self.contains(addon) && addon.matches('[data-addon]')) addon.checked = true;
        });
        if (this.sizing) {
          ['size', 'length'].forEach(function (kind) {
            var saved = kind === 'size' ? data.__readySize : data.__readyLength;
            if (!saved) return;
            var inputs = self.sizing.querySelectorAll('[data-ready-' + kind + ']');
            Array.prototype.forEach.call(inputs, function (input) {
              if (input.value === saved) input.checked = true;
            });
          });
        }
        if (this.sizing && data.__sizeType) {
          var radio = this.sizing.querySelector('[data-size-type="' + data.__sizeType + '"]');
          if (radio) {
            radio.checked = true;
            this.applySizeType(data.__sizeType);
          }
        }
        this.customFields().forEach(function (field) {
          var input = self.inputFor(field);
          if (!input || !data[input.id] || input.value !== '') return;
          var entry = data[input.id];
          input.value = entry.v || '';
          if (entry.c && entry.cv === input.value) {
            self.setCatalogSource(field, entry.c, entry.cv);
          }
        });
      }

      clearDraft() {
        if (!this.store) return;
        try {
          this.store.removeItem(this.draftKey);
        } catch (e) { /* ignore */ }
      }

      /* ---------------- Colour catalogue ---------------- */
      openCatalog(trigger) {
        var dialog = document.getElementById(trigger.getAttribute('data-catalog-open'));
        var input = document.getElementById(trigger.getAttribute('data-catalog-target'));
        if (!dialog || !input) return;
        this.catalog = dialog;
        this.catalogInput = input;
        this.hideConfirm(false);

        var targetLabel = dialog.querySelector('[data-catalog-target-label]');
        if (targetLabel) targetLabel.textContent = fill(strings.choosingFor, { field: trigger.getAttribute('data-catalog-label') || '' });

        /* Open the tab matching the fabric the customer typed, if any. */
        var field = input.closest('[data-custom-field]');
        var fabricType = field && field.getAttribute('data-field') === 'secondary_color' ? 'secondary_fabric' : 'fabric';
        var fabricField = this.querySelector('[data-custom-field][data-field="' + fabricType + '"]');
        var fabricValue = fabricField ? this.inputFor(fabricField).value.trim().toLowerCase() : '';
        var source = field && field.querySelector('[data-catalog-source]');
        var sourceValue = source && !source.disabled ? source.value.toLowerCase() : '';
        var tabs = Array.prototype.slice.call(dialog.querySelectorAll('[data-catalog-tab]'));
        var match = null;
        var current = input.value.trim();
        if (sourceValue) {
          var named = tabs.filter(function (t) { return t.getAttribute('data-catalog-name').toLowerCase() === sourceValue; });
          /* Two catalogues can share a name; prefer the one that holds the chosen number. */
          match = named.find(function (t) {
            var panel = dialog.querySelector('#' + CSS.escape(t.getAttribute('aria-controls')));
            return panel && Array.prototype.some.call(panel.querySelectorAll('[data-swatch]'), function (sw) { return sw.getAttribute('data-code') === current; });
          }) || named[0] || null;
        }
        if (!match && fabricValue) {
          match = tabs.find(function (t) {
            var name = t.getAttribute('data-catalog-name').toLowerCase();
            return name && (fabricValue.indexOf(name) > -1 || name.indexOf(fabricValue) > -1);
          });
        }
        if (match) this.selectTab(match, false);

        /* Mark the sample that is currently in the field, within its own catalogue only. */
        dialog.querySelectorAll('[data-swatch]').forEach(function (swatch) {
          var selected = current !== '' &&
            swatch.getAttribute('data-code') === current &&
            (!sourceValue || swatch.getAttribute('data-catalog').toLowerCase() === sourceValue);
          swatch.classList.toggle('is-selected', selected);
          swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        if (theme.dialog) theme.dialog.open(dialog, trigger);
      }

      selectTab(tab, focus) {
        var dialog = tab.closest('dialog');
        if (!dialog) return;
        dialog.querySelectorAll('[data-catalog-tab]').forEach(function (t) {
          var active = t === tab;
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });
        dialog.querySelectorAll('[data-catalog-panel]').forEach(function (panel) {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
        if (focus) tab.focus();
      }

      pickSwatch(swatch) {
        if (!this.catalogInput) return;
        var pick = {
          code: swatch.getAttribute('data-code'),
          catalog: swatch.getAttribute('data-catalog'),
          swatch: swatch
        };
        var current = this.catalogInput.value.trim();
        var previousPick = this.catalogInput.dataset.catalogValue;
        /* Never overwrite something the customer typed without asking. */
        if (current !== '' && current !== previousPick && current !== pick.code) {
          this.pendingPick = pick;
          var confirm = this.catalog.querySelector('[data-catalog-confirm]');
          var text = this.catalog.querySelector('[data-catalog-confirm-text]');
          if (text) text.textContent = fill(strings.replacePrompt, { current: current, code: pick.code });
          if (confirm) {
            confirm.hidden = false;
            var replace = confirm.querySelector('[data-catalog-replace]');
            if (replace) replace.focus();
          }
          return;
        }
        this.applyPick(pick);
      }

      applyPick(pick) {
        var input = this.catalogInput;
        var field = input.closest('[data-custom-field]');
        input.value = pick.code;
        this.setCatalogSource(field, pick.catalog, pick.code);
        this.validateField(field);
        this._draftCleared = false;
        this.saveDraft();
        this.hideConfirm(false);
        this.pendingPick = null;
        announce(fill(strings.fromCatalog, { catalog: pick.catalog }) + ': ' + pick.code);
        if (theme.dialog && this.catalog) theme.dialog.close(this.catalog, { restoreFocus: false });
        window.setTimeout(function () { input.focus(); }, reduceMotion.matches ? 0 : 220);
      }

      setCatalogSource(field, catalog, code) {
        var input = this.inputFor(field);
        var source = field.querySelector('[data-catalog-source]');
        var hint = field.querySelector('[data-catalog-hint]');
        input.dataset.catalogValue = code;
        if (source) {
          source.value = catalog;
          source.disabled = false;
        }
        if (hint) {
          hint.textContent = fill(strings.fromCatalog, { catalog: catalog });
          hint.hidden = false;
        }
      }

      clearCatalogSource(field) {
        var input = this.inputFor(field);
        var source = field.querySelector('[data-catalog-source]');
        var hint = field.querySelector('[data-catalog-hint]');
        delete input.dataset.catalogValue;
        if (source) {
          source.value = '';
          source.disabled = true;
        }
        if (hint) {
          hint.textContent = '';
          hint.hidden = true;
        }
      }

      hideConfirm(returnFocus) {
        if (!this.catalog) return;
        var confirm = this.catalog.querySelector('[data-catalog-confirm]');
        if (confirm) confirm.hidden = true;
        if (returnFocus && this.pendingPick && this.pendingPick.swatch) this.pendingPick.swatch.focus();
        if (returnFocus) this.pendingPick = null;
      }

      /* ---------------- Add to cart ---------------- */
      showFormError(message) {
        var box = this.form && this.form.querySelector('[data-form-error]');
        if (!box) return;
        box.textContent = message || '';
        box.hidden = !message;
      }

      onSubmit(event) {
        event.preventDefault();
        var self = this;
        this.attempted = true;
        this.showFormError('');

        var firstInvalid = this.validateAll();
        if (firstInvalid) {
          this.showFormError(strings.errorSummary);
          firstInvalid.focus();
          firstInvalid.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          return;
        }

        var button = this.form.querySelector('[data-add-button]');
        var label = button && button.querySelector('[data-add-label]');
        var idInput = this.form.querySelector('[data-variant-id]');
        if (!idInput || idInput.disabled || (button && button.disabled)) return;

        /* FormData includes every field associated with the form through its form attribute. */
        var formData = new FormData(this.form);
        var entries = [];
        formData.forEach(function (value, key) { entries.push([key, value]); });
        entries.forEach(function (entry) {
          var key = entry[0];
          if (key.indexOf('properties[') !== 0) return;
          formData.delete(key);
        });
        entries.forEach(function (entry) {
          var key = entry[0];
          var value = entry[1];
          if (key.indexOf('properties[') !== 0) return;
          var trimmed = typeof value === 'string' ? value.trim() : value;
          if (trimmed === '') return;
          var field = null;
          self.customFields().some(function (f) {
            var input = self.inputFor(f);
            if (input && input.name === key) {
              field = f;
              return true;
            }
            return false;
          });
          if (field && (field.getAttribute('data-numeric') === 'true' || field.getAttribute('data-field') === 'color')) trimmed = toLatinDigits(trimmed);
          formData.append(key, trimmed);
        });

        /*
         * Paid add-ons (Add Al Oqom). The piece and the add-on variant are added
         * in ONE request and linked by a private bundle id, so:
         * - the add-on price is really part of the cart, checkout and order total;
         * - the choice is written on this piece's own line ("Add Al Oqom: Yes (+10 AED)");
         * - nothing is added to any other product in the cart.
         */
        var addons = this.checkedAddons();
        var items = null;
        if (addons.length) {
          if (this.invalidAddon()) {
            this.showFormError(strings.addonUnavailable || strings.cartError);
            return;
          }
          var props = {};
          formData.forEach(function (value, key) {
            var m = key.match(/^properties\[(.*)\]$/);
            if (m && typeof value === 'string') props[m[1]] = value;
          });
          var bundle = 'AB-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
          var quantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
          addons.forEach(function (el) {
            props[el.getAttribute('data-addon-key')] = el.getAttribute('data-addon-value');
          });
          props._bundle_id = bundle;
          items = [{ id: Number(idInput.value), quantity: quantity, properties: props }];
          addons.forEach(function (el) {
            items.push({
              id: Number(el.getAttribute('data-addon-variant')),
              quantity: quantity,
              properties: {
                _almarzooqi_addon: 'true',
                _bundle_id: bundle,
                'For Product': el.getAttribute('data-addon-for') || 'Product',
                Option: el.getAttribute('data-addon-label') || 'Add-on'
              }
            });
          });
        }

        if (!window.ThemeCart) {
          if (!items) {
            this.form.submit();
            return;
          }
          /* Without the theme cart script, still add the add-on with its piece. */
          fetch((theme.routes.cartAdd || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: items })
          })
            .then(function (response) {
              if (!response.ok) throw new Error(strings.cartError);
              window.location.href = theme.routes.cart || '/cart';
            })
            .catch(function (error) { self.showFormError(error.message || strings.cartError); });
          return;
        }

        if (button) {
          button.classList.add('is-loading');
          button.setAttribute('aria-disabled', 'true');
          button.disabled = true;
        }
        if (label) label.textContent = strings.adding;

        (items ? window.ThemeCart.addItems(items) : window.ThemeCart.add(formData))
          .then(function () {
            self.clearDraft();
            self._draftCleared = true;
            announce(strings.added);
            if (theme.cartType === 'page') {
              window.location.href = theme.routes.cart;
              return;
            }
            if (!window.ThemeCart.openDrawer(button)) {
              window.location.href = theme.routes.cart;
            }
          })
          .catch(function (error) {
            self.showFormError(error.message || strings.cartError);
            var box = self.form.querySelector('[data-form-error]');
            if (box) box.focus();
          })
          .finally(function () {
            if (!button) return;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-disabled');
            var variant = self.findVariant(self.selectedOptions()) || (self.product && self.product.variants.find(function (v) { return String(v.id) === String(idInput.value); }));
            var available = variant ? variant.available : true;
            button.disabled = !available;
            if (label) label.textContent = available ? strings.addToCart : strings.soldOut;
          });
      }
    });
  }
})();
